import { render, staticRenderFns } from "./enable.vue?vue&type=template&id=623bf9c1&scoped=true&"
import script from "./enable.vue?vue&type=script&lang=js&"
export * from "./enable.vue?vue&type=script&lang=js&"
import style0 from "./enable.vue?vue&type=style&index=0&id=623bf9c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623bf9c1",
  null
  
)

export default component.exports